import { render } from "./IconInvestedRoundedType8.vue?vue&type=template&id=6e7896d2&ts=true"
import script from "./IconInvestedRoundedType8.vue?vue&type=script&lang=ts"
export * from "./IconInvestedRoundedType8.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__